import React from "react";
import { Box } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Slide from "react-reveal/Slide";
import classes from "./Project.module.css";
// import projectURL from "../../../asset/projects/palatable/soundGame.html";

const Project = (props) => {
  // console.log(props.name)
  return (
    <Slide left>
      <Box mx={6} my={2}>
        <Grid container spacing={3} className={classes.block}>
          <Grid item xs={12} sm={5} md={3}>
            <img src={props.info.img} className={classes.img} alt={props.info.name}></img>
          </Grid>
          <Grid item xs={12} sm={7} md={9}>
            <a
              href={props.info.link}
              target="_blank"
              className={classes.projectName}
              rel="noopener noreferrer"
            >
              <h1 className={classes.projectName}>{props.info.name}</h1>
            </a>
            <h4 className={classes.title}> <i>{props.info.title}</i></h4>
  <h6 className={classes.location}>{props.info.location}   |   {props.info.date}</h6>
            <p>{props.info.description}</p>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Project;
